@if (view == true) {
  <div>
    <app-carousel>
      <ng-template carouselItem="1">
        <ng-container *ngTemplateOutlet="matDescription"></ng-container>
      </ng-template>
      <ng-template carouselItem="2">
        <mat-card appearance="outlined" style="height: 70vh" class="mat-card-c">
          <mat-card-content class="mat-body-1">
            <h2 style="display: flex; justify-content: center;"><strong>Recursos</strong></h2>
            <app-button-label [labelsEdit]="labels"></app-button-label>
            <data-table
              [title]=''
              [columns]='columnsResouces'
              [configuration]='configurationResouces'
              [url]='urlGetTablaResources'
              [params]='paramsResources'
              (internalData)="dataResources($event)">
            </data-table>
          </mat-card-content>
        </mat-card>
      </ng-template>
    </app-carousel>
  </div>
}

<ng-container *ngTemplateOutlet="buttons"></ng-container>

<ng-template #matDescription>
  @if (view == true) {
    <div>
      @if (view == true) {
        <mat-card appearance="outlined" class="mat-card-c" style="height: 70vh">
          <mat-card-content class="mat-body-1">
            <div class="d-flex justify-content-end">
              <div>
                @if (bodyPurchaseOrder.created) {
                  <h4 class="m-0 p-0 text-center font-weight-bold"
                  [style]="movil?'font-size: x-small; line-height: 0.6;':''"> Creación Solicitud</h4>
                }
                <h3 class="m-0 p-0 text-center" [style]="movil?'font-size: x-small;':''">{{bodyPurchaseOrder.created | dateFormat}}</h3>
              </div>
            </div>
            <h2 style="display: flex; justify-content: center;"><strong>Solicitud Orden de Compra</strong></h2>
            <h3>Consecutivo (#): {{bodyPurchaseOrder.consecutive}}</h3>
            <h3>Solicita: {{bodyPurchaseOrder.requestsName}}</h3>
            <h3>Autoriza: {{bodyPurchaseOrder.authorizeName}}</h3>
            <h3>Proveedor: {{bodyPurchaseOrder.providerName}}</h3>
            <h3>Fecha de Repcion: {{bodyPurchaseOrder.receptionDate}}</h3>
            <h3>Comentario: {{bodyPurchaseOrder.comment}}</h3>
            <h3>Costo Total: {{bodyPurchaseOrder.totalCost | thousandSeparator}}</h3>
          </mat-card-content>
        </mat-card>
      }
    </div>
  }
</ng-template>

<ng-template #buttons>
  <!-- button -->
  <div style="justify-content: space-between;" class="button">
    <button style="width: 45%;" color="warn" class="button-save mat-elevation-z5 " mat-raised-button
    (click)="response('rechazar')">Rechazar</button>
    <button type="submit" style="width: 45%;" color="primary" class="button-save mat-elevation-z5 " mat-raised-button
    (click)="response('autorizar')">Autorizar</button>
  </div>
</ng-template>